import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { newsActions } from '../../store/newsStore';

import Remove from "../../img/icons/BBiconsOdstranit";
import CalendarIcon from '../../img/icons/Kalendar';

import "./news.css";

class NewsFooter extends React.Component {
    render() {
        const { date, annotation, notificationId, seen, isProcessing } = this.props;

        return (
            <div className="bb-news-widget-footer bb-news-widget-date-box">
                <table style={{ width: '100%', border: 'none' }}>
                    <tbody>
                        <tr style={{ border: 'none' }}>
                            <td style={{ alignItems: 'left' }} valign="middle">
                                <div className="bb-news-widget-date-box" style={{ marginLeft: '1em' }}>
                                    <CalendarIcon fill='#969DA1' style={{ height: '1.2em', width: '1.2em' }} />
                                    <span> </span>
                                    <div className="bb-news-widget-date small">{date}</div>
                                    <div className='news-annotations' style={{ marginLeft: '1em' }}>
                                        {typeof annotation === 'string' && annotation.length > 0 && annotation.split(';').map(a =>
                                            <span key={a.trim()} className='news-annotation'>{a.trim()}</span>
                                        )}
                                    </div>
                                </div>
                            </td>
                            <td style={{ alignItems: 'right' }} valign="middle">
                                <div align="right" style={{ marginRight: '1em' }}>
                                    {seen && <span style={{ marginRight: '1em' }}>
                                        <span style={{ paddingLeft: "1em" }}>{this.props.translate("Table.Showing")}</span>
                                        <span>: </span>
                                        <div className="bb-news-widget-date small">{seen}</div>
                                    </span>}
                                    {notificationId && isProcessing && <span className="m-right-btn">
                                        <FontAwesomeIcon icon='cog' spin={true} />
                                    </span>}
                                    {notificationId && !isProcessing && <span className="m-right-btn">
                                        <div className="ml-link color">
                                            <div className="ml-link-inner">
                                                <a className='link-internal' onClick={() => this.dismissNotification(notificationId)}>
                                                    <Remove className="ml-link-icon" />
                                                    {this.props.translate("Common.Button.Delete")}
                                                </a>
                                            </div>
                                        </div>
                                    </span>}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    dismissNotification = (id) => {
        this.props.updateNotificationsStatus(3, id);
    }
}

export default withLocalize(connect(state => state.news, dispatch => bindActionCreators(newsActions, dispatch))(NewsFooter));
